export default {
  name: 'TableSku',
  props: {
    itemdata: {
      type: Object
    },
    row: {
      type: Object
    },
    showCol: {
      type: String,
      default: 'PS_C_SKU_ECODE'
    },
    queryApi: {
      type: String,
      default: 'selectProInfoLike'
    }
  },
  components: {},
  data() {
    return {
      value: '', // 选中值 v-model 绑定
      queryList: [], // 模糊搜索项目
      isSelected: false, // 是否选中项
    };
  },
  watch: {
    value(val) {
      // 输入框有内容就显示选项（不适用促销，目前用于全渠道发货单-装箱复核）
      if (this.itemdata.hasOwnProperty('hasValShowPop')) {
        setTimeout(() => { // 偶现下拉框未显示，定时器解决
          let node = $(`.fkAutocomplete${this.itemdata.colname}`)
          if (val && node.length) {
            node[0].style.visibility = 'initial'
            node[0].style.display = 'block'
            node[0].style.zIndex = 9000
          } else if (!val) {
            node[0].style.visibility = 'hidden'
          }
        }, 1500)
      }
    },
  },
  methods: {
    /**
     * 搜索
     * @val 关键字
     * @val 回调
     */
    async handleSearch(val, cb) {
      const self = this;
      const params = {
        table: this.itemdata.reftable,
        like: val
      };
      const serachParams = new URLSearchParams();
      serachParams.append('param', JSON.stringify(params));
      try {
        if (this.$listeners['cusGetdata']) {
          await this.$emit('cusGetdata', {value: this.value, callback:(res) => {
            const { data: { code, data } } = res
            if (code === 0) {
              self.queryList = data;
              cb(self.queryList);
            } else {
              self.queryList = [];
            }
          }})
        } else {
          const { data: { code, data, message } } = await this.service.promotionCenter[this.queryApi](serachParams);
          if (code === 0) {
            self.queryList = data;
            cb(self.queryList);
          } else {
            /* this.$message({
              type: 'error',
              message: message || '错误！'
            }); */
            self.queryList = [];
          }
        }
      } catch (error) {
        self.queryList = [];
        cb([]);
        // hasValShowPop配置控制pop选项隐藏方式，display：none，会导致装箱复核输入搜索时无法弹出pop
        if (this.itemdata.hasOwnProperty('hasValShowPop')) {
          $(`.fkAutocomplete${self.itemdata.colname}`).css('visibility', 'hidden');
        } else {
          $(`.fkAutocomplete${self.itemdata.colname}`).css('display', 'none');
        }
      }
    },
    /**
     * 选中项目
     */
    handleSelect(val) {
      const obj = val;
      if (obj) {
        // 当前选中项
        this.isSelected = true;
        this.confirmResult(obj);
      } else {
        this.isSelected = false;
      }
    },
    autocompleteEnter() {
      const self = this;
      if (this.itemdata.hasOwnProperty('hasValShowPop')) return // 装箱复核不执行回车事件
      if (this.isSelected) {
        return true;
      }
      if (this.queryList.length > 0) {
        this.confirmResult(self.queryList[0]);
      } else {
        this.clearResult();
      }
      if (this.itemdata.hasOwnProperty('hasValShowPop')) {
        $(`.fkAutocomplete${self.itemdata.colname}`).css('visibility', 'hidden');
      } else {
        $(`.fkAutocomplete${self.itemdata.colname}`).css('display', 'none');
      }
    },
    autocompleteBlur() {
      if (this.itemdata.hasOwnProperty('hasValShowPop')) return // 装箱复核不执行失焦事件
      const self = this;
      setTimeout(() => {
        if (this.isSelected) return;
        if (self.queryList.length > 0) {
          self.confirmResult(self.queryList[0]);
        } else if (self.queryList.length === 0 && self.value === '') {
          self.clearResult();
        } else {
          self.blurInQuery();
        }
        self.queryList = [];
        if (this.itemdata.hasOwnProperty('hasValShowPop')) {
          $(`.fkAutocomplete${self.itemdata.colname}`).css('visibility', 'hidden');
        } else {
          $(`.fkAutocomplete${self.itemdata.colname}`).css('display', 'none');
        }
      }, 500);
    },
    async blurInQuery() {
      const params = {
        table: this.itemdata.reftable,
        like: this.value
      };
      const serachParams = new URLSearchParams();
      serachParams.append('param', JSON.stringify(params));
      try {
        const { data: { code, data } } = await this.service.promotionCenter[this.queryApi](serachParams);
          if (code === 0) {
          if (data.length === 0) {
            this.value = [];
            this.queryList = [];
          }
        }
      } catch (error) {
        this.value = [];
        this.queryList = [];
      }
    },
    keyUp(event) {
      const self = this;
      if (self.$listeners['onChange']) {
        self.$emit('onChange', event)
      }
      if (event.keyCode !== 13) {
        self.isSelected = false;
        self.queryList = [];
      }
      if (this.value === '') {
        this.confirmResult();
      }
    },
    /**
     *  批量查询数据
     *  @id  款号id
     */
    async selectProInfo(id) {
      const params = {
        table: this.itemdata.reftable,
        ids: [id]
      };
      const serachParams = new URLSearchParams();
      serachParams.append('param', JSON.stringify(params));
      const res = await this.service.promotionCenter.selectProInfo(serachParams);
      if (res.data.code !== 0) {
        this.$Message.error(res.data.message);
        // this.$message({
        //   type: 'error',
        //   message: res.data.message
        // });
      }
    },
    /**
     * 确认选中结果
     */
    confirmResult(item) {
      this.value = item ? String(item[this.showCol]) : '';
      this.$emit('getFilterChooseItem', item, this.row);
      this.itemdata.autoClearValue && this.clearResult() // 选中后清空输入框
    },
    clearResult() {
      this.value = '';
      this.$emit('clearFilterChooseItem', this.row);
    },
    /**
    初始化
     */
    init() {
      const showCol = this.itemdata.showCol || 'ECODE'
      this.value = this.row[showCol];
    }
  },
  mounted() {
    this.init();
  },
  created() {}
};
